module.exports = __webpack_public_path__ + "static/media/canada0.c7402012.jpg";